import {
  Button,
  Collapse,
  Icon,
  ListItem,
  ListItemProps,
  chakra,
  useDisclosure,
} from "@chakra-ui/react";
import { ReactElement, ReactNode } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { ELLIPSISE } from "../../core/utils";

interface SidebarGroupProps extends Omit<ListItemProps,"left"> {
  label: string;
  left?: ReactNode;
  children: ReactNode;
}

export default function SidebarGroup(props: SidebarGroupProps): ReactElement {
  const { label, left, children, ...rest } = props;

  const { isOpen, onToggle } = useDisclosure();

  return (
    <ListItem maxW="100%" {...rest}>
      <Button
        bg="gray.50"
        justifyContent="space-between"
        w="100%"
        fontWeight="normal"
        rounded="0"
        px="2"
        onClick={onToggle}
        border="0 !important"
        outline="0 !important"
        _hover={{ bg: undefined }}
        _active={{ bg: undefined }}
      >
        {left}
        <chakra.span
          ms={left != null ? "2" : undefined}
          {...ELLIPSISE}
          w="100%"
          h="100%"
          display="flex"
          alignItems="center"
          textAlign="start"
        >
          {label}
        </chakra.span>
        <Icon as={isOpen ? FiChevronUp : FiChevronDown} />
      </Button>
      <Collapse in={isOpen}>{children}</Collapse>
    </ListItem>
  );
}
